module.exports = __webpack_public_path__ + "img/filetype_doc.7a797638.png";